import Cookies from 'universal-cookie';

import { decrypt, encrypt } from './encrypt';

const cookies = new Cookies(null, { path: '/' });

export const setUserToken = (data: ITokenData) =>
  cookies.set('moni-web-user', encrypt(JSON.stringify(data)));

export const getUserToken = (): ITokenData => {
  try {
    return cookies.get('moni-web-user')
      ? JSON.parse(decrypt(cookies.get('moni-web-user')!))
      : { accessToken: '', refreshToken: '' };
  } catch (err) {
    console.error(err);
    return { accessToken: '', refreshToken: '' };
  }
};

export const removeUserToken = () => cookies.remove('moni-web-user');

interface ITokenData {
  accessToken: string;
  refreshToken: string;
}
